module.exports = __webpack_public_path__ + "static/media/sample-document.ce355ba2.pdf";